import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './Avatar.Styles';

const Avatar = ({ placeholder, containerStyle }) => {
  const theme = useTheme();
  return (
    <View style={[styles.placeholderContainer(theme), containerStyle]}>
      <VFText
        i18nKey={placeholder}
        adjustsFontSizeToFit
        numberOfLines={1}
        minimumFontScale={0.01}
        style={styles.placeholderText(theme)}
      />
    </View>
  );
};

Avatar.propTypes = {
  placeholder: PropTypes.string,
  containerStyle: ViewPropTypes.style,
};

export default Avatar;
